import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Abeille = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 81.12 98.22">
  <G fill={color}>
    <Path d="M68.33,41.7c-4.2-3.35-8.7-5.76-13-7.04,1.17-2.27,1.84-4.84,1.84-7.56,0-3.41-1.04-6.58-2.81-9.22,2.95-4.81,6.86-7.8,12.15-9.31,2.32-.66,3.66-3.08,2.99-5.4-.66-2.32-3.09-3.66-5.4-2.99-6.98,2-12.36,5.95-16.39,11.96-2.17-1.04-4.59-1.64-7.15-1.64s-5,.61-7.18,1.66C29.34,6.13,23.96,2.17,16.97.17c-2.31-.67-4.73.68-5.4,2.99-.66,2.32.68,4.73,2.99,5.4,5.29,1.52,9.21,4.52,12.17,9.35-1.76,2.63-2.79,5.79-2.79,9.19,0,2.73.67,5.29,1.84,7.57-4.3,1.28-8.81,3.69-13,7.04C1.34,50.84-3.16,63.01,2.33,70.01c1.86,2.37,4.66,3.84,8.09,4.24.65.08,1.31.11,1.99.11,2.56,0,5.33-.56,8.17-1.56,1.1,14.49,9.47,25.41,19.97,25.41s18.87-10.93,19.98-25.41c2.84,1,5.61,1.56,8.17,1.56.68,0,1.35-.04,1.99-.11,3.43-.4,6.22-1.87,8.09-4.24,5.49-7,.99-19.16-10.46-28.31ZM40.56,19.22c4.35,0,7.88,3.53,7.88,7.88s-3.53,7.88-7.88,7.88-7.88-3.53-7.88-7.88,3.53-7.88,7.88-7.88ZM40.56,57.33c1.37,2.01,3.05,4,5.01,5.91-3.34-.37-6.68-.37-10.02,0,1.96-1.91,3.64-3.9,5.01-5.91ZM26.71,59.43c-5.98,4.78-12,6.53-15.28,6.15-.74-.09-1.73-.32-2.23-.96-1.71-2.17,1.03-9.7,9.04-16.1,5.46-4.36,10.93-6.2,14.35-6.2.33,0,.64.02.93.05.74.09,1.73.32,2.23.96.25.32.39.77.45,1.3-.01.38-.03.76-.01,1.16-.39,3.33-3.42,8.8-9.48,13.64ZM40.56,89.49c-2.38,0-4.63-1.45-6.5-3.82,4.35-.75,8.66-.75,13,0-1.87,2.38-4.13,3.82-6.5,3.82ZM50.9,77.52c-6.88-1.52-13.81-1.52-20.69,0-.35-1.33-.63-2.72-.8-4.17,7.5-2.27,14.8-2.26,22.3,0-.17,1.44-.45,2.84-.8,4.17ZM71.92,64.62c-.5.63-1.49.87-2.23.96-3.28.38-9.3-1.37-15.28-6.15-6.05-4.83-9.09-10.31-9.48-13.64.02-.39,0-.77-.01-1.16.06-.53.2-.98.45-1.3.5-.63,1.49-.87,2.23-.96.29-.03.6-.05.93-.05,3.42,0,8.89,1.84,14.35,6.2,8.01,6.39,10.75,13.92,9.04,16.1Z"/>
  </G>
</Svg>
);
};

export default Abeille;
